var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 33"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-camera_svg__a",
    width: "136%",
    height: "267.5%",
    x: "-18%",
    y: "-78.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon-camera_svg__a)",
    transform: "translate(-6 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.438 13.188l-.938 1.874h-3.188A1.31 1.31 0 0016 16.375v8.25a1.31 1.31 0 001.313 1.313h12.75a1.31 1.31 0 001.312-1.313v-8.25a1.31 1.31 0 00-1.313-1.313h-3.187l-.938-1.874h-4.5zm2.25 3.562a3.756 3.756 0 013.75 3.75 3.756 3.756 0 01-3.75 3.75 3.756 3.756 0 01-3.75-3.75 3.756 3.756 0 013.75-3.75zm0 .75c-1.662 0-3 1.339-3 3s1.338 3 3 3c1.66 0 3-1.339 3-3s-1.34-3-3-3z"
  }))));
}

export default SvgIconCamera;